import { DropdownOptionModel } from './dropdown-option-model';
import {
  PropertyRequest
} from '../shared/models';
import PropertyType = PropertyRequest.PropertyTypeEnum;

export const PROPERTY_TYPE_OPTIONS: DropdownOptionModel<PropertyType>[] = [
  { value: PropertyType.SingleFamilyDetached, display: 'Single Family Detached' },
  { value: PropertyType.SingleFamilyAttached, display: 'Single Family Attached' },
  { value: PropertyType.PropertyUnderDevelopment, display: 'Planned Unit Development' },
  { value: PropertyType.AttachedLowRiseCondoOneToFour, display: 'Condo Low Rise 1-4 Stories' },
  { value: PropertyType.AttachedMidRiseCondoFiveToEight, display: 'Condo Mid Rise 5-8 Stories' },
  { value: PropertyType.AttachedHighRiseCondoNinePlus, display: 'Condo High Rise 9+ Stories' },
  { value: PropertyType.ManufacturedHome, display: 'Manufactured' },
  { value: PropertyType.TwoUnit, display: '2-Unit' },
  { value: PropertyType.ThreeUnit, display: '3-Unit' },
  { value: PropertyType.FourUnit, display: '4-Unit' }
];
